import { TTranslationMessages } from "@desktop/types";
import { Context } from "@shared/containers/Context";
import { translationMessages } from "@shared/i18n";
import { StrictMode } from "react";
import { render } from "react-dom";

import { Root } from "./Root";
import configureStore from "./store/configureStore";

import "./index.css";
import "./style/style.scss";
// eslint-disable-next-line import/order,import/named
import { Store } from "redux";

const storage = configureStore();
const rootElement = document.querySelector("#root");
const renderRoot = (translationMessages: TTranslationMessages) => {
  render(
    <StrictMode>
      <Context>
        <Root
          store={storage.store as Store}
          persistor={storage.persistor as never}
          messages={translationMessages}
        />
      </Context>
    </StrictMode>,
    rootElement
  );
};

renderRoot(translationMessages);
